import Head from 'next/head'

/**
 * Overrride the head meta tags based on values avaliable to the client side (i.e window)
 * @returns JSX.Element
 */
const ClientSideHead: React.FC = () => {
  if (typeof window === 'undefined') {
    console.warn(
      'ClientSideHead component must be used on the client side only. Try wrapping the import in the next/dynamic component with SSR disabled.',
    )
    return null
  }

  const overrides = {
    noRobots: window.location.origin !== 'https://www.cinch.co.uk',
  }

  const numEnabledOverrides = Object.values(overrides).filter(Boolean).length

  if (numEnabledOverrides === 0) {
    return null
  }

  return (
    <Head>
      {overrides.noRobots && <meta name="robots" content="none" key="robots" />}
    </Head>
  )
}

export default ClientSideHead
